module.exports = __webpack_public_path__ + "img/UTOTTE.5a70306a.png";